import {focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {ExperimentNames, getEventId} from '@wix/wix-events-commons-statics'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useWidgetActions, useWidgetState} from '../../../../../../hooks/state-provider'
import {getDayMonthText, getEventsForDay, getSelectedDate} from '../../../../../../selectors/calendar-layout'
import {getCompId} from '../../../../../../selectors/component'
import {PopupHeader} from '../header'
import {MonthlyCalendarEventListItem} from './event-list-item'
import s from './monthly-calendar-event-list.scss'

export const MonthlyCalendarEventList = () => {
  const {
    closeMonthlyCalendarPopup: closeMonthlyCalendarPopupAction,
    openMonthlyCalendarEvent: openMonthlyCalendarEventAction,
  } = useWidgetActions()
  const {experiments} = useExperiments()
  const selectedDate = useWidgetState(getSelectedDate)
  const events = useWidgetState(state => getEventsForDay(state, selectedDate))
  const dateText = useWidgetState(state => getDayMonthText(state, selectedDate))
  const componentId = useWidgetState(getCompId)

  const calendarRevampEnabled = experiments.enabled(ExperimentNames.CalendarRevamp)

  const openMonthlyCalendarEvent = (eventId: string) => {
    openMonthlyCalendarEventAction({eventId, selectedDate})
    calendarRevampEnabled &&
      setTimeout(
        () =>
          focusElement({
            selector: hookToAttributeSelector(DH.calendarPopupBackButton, {componentId}),
            canFocus: true,
            preventScroll: true,
          }),
        50,
      )
  }

  const closeMonthlyCalendarPopup = () => {
    closeMonthlyCalendarPopupAction()
    calendarRevampEnabled &&
      focusElement({
        selector: hookToAttributeSelector(DH.calendarCell(selectedDate), {componentId}),
        canFocus: true,
        preventScroll: true,
      })
  }

  return (
    <div className={classNames(s.container, {[s.revamp]: calendarRevampEnabled})} data-hook="calendar-event-list">
      <PopupHeader eventList text={dateText} onClose={closeMonthlyCalendarPopup} />
      <ul className={calendarRevampEnabled ? s.scrollableList : s.list}>
        {events.map(event => {
          const eventId = getEventId(event)

          return (
            <MonthlyCalendarEventListItem
              key={eventId}
              event={event}
              selectedDate={selectedDate}
              onClick={() => {
                openMonthlyCalendarEvent(eventId)
              }}
            />
          )
        })}
      </ul>
    </div>
  )
}
